export default __webpack_public_path__ + "ebccda676547887ae7e42ae9ecf91c1d.png";